import React from 'react';
export default function AuthCard({ children, variant = 'form' }) {
  return <section className={`auth-card auth-card--${variant}`}>{children}</section>;
}
